// extracted by mini-css-extract-plugin
module.exports = {"container":"S","timeTop":"T","timeCountdown":"U","cta":"V","disabled":"W","product":"X"};